import { log2 } from "../../utils/log2";
import {
    getCalendarEvents,
    getEventDetail,
    updateCalendarEvent,
    getCalendarSettings,
    getTaskEvents,
    markCompletedTask,
    isEnableUserAccount,
    getUserCalendars,
    createDefaultCalendar,
    createCalendar,
    updateCalendarColor,
    getCalendarList,
    calendarDisconnect,
    getTodayEvents,
    updateSetting,
    getVisitorEvents,
    changeVisibility,
    getCalendarDetail,
    deleteCalendar,
} from "../../api/calendar";

const log = log2("calendar");
const calendar = {
    namespaced: true,
    state: {
        newEvent: {},
        updatedEvent: {},
        newCalendar: {},
        deleteEvent: {},
        connectSuccess: false,
        isAllDeleteEvents: false,
        calendarList: [],
    },
    getters: {},
    mutations: {
        addNewCalendar(state, data) {
            console.log("addNewCalendar module..", data);
            state.newCalendar = data;
        },
        addNewEvent(state, data) {
            console.log("addNewEvent module..", data);
            state.newEvent = data;
        },
        updateEvent(state, data) {
            console.log("updatedEvent module..", data);
            state.updatedEvent = data;
        },
        deleteEvent(state, data) {
            console.log("deleteEvent module..", data);
            state.deleteEvent = data;
        },
        calendarSuccess(state, data) {
            console.log("calendarSuccess module..", data);
            state.connectSuccess = data;
        },
        isAllDeleteEvents(state) {
            console.log("isAllDeleteEvents module..");
            state.isAllDeleteEvents = !state.isAllDeleteEvents;
        },
        setCalendarList(state, data) {
            state.calendarList = data;
        },
    },
    actions: {
        async updateCalendarEvent({ commit }, { eventId, data }) {
            return await updateCalendarEvent(eventId, data).then((res) => res.data);
        },
        async getCalendarEvents({ commit }, { calendarIds, userId, startDate, endDate }) {
            return await getCalendarEvents(calendarIds, userId, startDate, endDate).then((res) => res.data);
        },
        async getEventDetail({ commit }, eventId) {
            return await getEventDetail(eventId).then((res) => res.data);
        },
        async getCalendarSettings({ commit }, { userId }) {
            return await getCalendarSettings(userId).then((res) => res.data);
        },
        async getTaskEvents({ commit }, { userId }) {
            return await getTaskEvents(userId).then((res) => res.data);
        },
        async markCompletedTask({ commit }, { eventId }) {
            return await markCompletedTask(eventId).then((res) => res.data);
        },
        async isEnableUserAccount({ commit }, { userId }) {
            return await isEnableUserAccount(userId).then((res) => res.data);
        },
        async createDefaultCalendar({ commit }, { userId, userName }) {
            return await createDefaultCalendar(userId, userName).then((res) => res.data);
        },
        async getUserCalendars({ commit }, userId) {
            return await getUserCalendars(userId).then((res) => res.data);
        },
        async createCalendar({ commit }, { userId, payload }) {
            return await createCalendar(userId, payload).then((res) => res.data);
        },
        async updateCalendarColor({ commit }, { userId, payload }) {
            return await updateCalendarColor(userId, payload).then((res) => res.data);
        },
        async getCalendarList({ commit }, { userId, userName }) {
            const result = await getCalendarList(userId, userName).then((res) => res.data);
            commit("setCalendarList", result);
            return result;
        },
        async calendarDisconnect({ commit }, { userId, authId, isDeleteAll }) {
            return await calendarDisconnect(userId, authId, isDeleteAll).then((res) => res.data);
        },
        async getTodayEvents({ commit }, userId) {
            return await getTodayEvents(userId).then((res) => res.data);
        },
        async updateSetting({ commit }, { userId, setting, value }) {
            return await updateSetting(userId, setting, value).then((res) => res.data);
        },
        async getVisitorEvents({ commit }, { visitorId, page, pageSize }) {
            return await getVisitorEvents(visitorId, page, pageSize).then((res) => res.data);
        },
        async changeVisibility({ commit }, { calendarId, visibility }) {
            return await changeVisibility(calendarId, visibility).then((res) => res.data);
        },
        async getCalendarDetail({ commit }, calendarId) {
            return await getCalendarDetail(calendarId).then((res) => res.data);
        },
        async deleteCalendar({ commit }, { userId, calendarId, isDeleteEvents }) {
            return await deleteCalendar(userId, calendarId, isDeleteEvents).then((res) => res.data);
        },
    },
};

export default calendar;
